// f:/checkin/frontend/src/components/ui/FAQAccordion.jsx
import React from 'react';
import FAQAccordionItem from './FAQAccordionItem'; // Imports from the same directory

const FAQAccordion = ({ faqs }) => {
    if (!faqs || faqs.length === 0) {
        return <p>No hay preguntas frecuentes disponibles en este momento.</p>;
    }

    return (
        <div className="accordion" id="faqAccordion">
            {faqs.map((faq, index) => (
                <FAQAccordionItem
                    key={faq.id}
                    id={faq.id}
                    question={faq.question}
                    answer={faq.answer}
                    isFirstItem={index === 0}
                />
            ))}
        </div>
    );
};

export default FAQAccordion;
